import React, { Children, useEffect } from "react";
import media from "../../../media";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment/moment";
import CardHeader from "../../../components/atoms/cardHeader";
import TableLoader from "../../../components/atoms/Loader/tableLoader";
import { productReviewsThunk } from "../../../store/thunks/dashboardThunk";
import AllToolTip from "../../../components/atoms/Tooltip/AllToolTips";

const ProductReviews = () => {
  const dispatch = useDispatch();
  const { loading, list } = useSelector(
    (state) => state?.dashboardProductReviews || {},
  );
  useEffect(() => {
    dispatch(
      productReviewsThunk({
        paginationFilter: {
          limit: 10,
          offset: 0,
          order: "DESC",
        },
      }),
    );
  }, []);

  return (
    <div className="card card-custom h-100">
      <div className="bg-gray-700 border-1 border-bottom card-header min-h-auto py-3">
        <h4
          className="card-label font-weight-bold text-white"
          style={{ margin: " 7px 0" }}
        >
          Product Reviews{" "}
          <AllToolTip text="latest 10 of customer reviews received for products." />
        </h4>
      </div>

      <div className="padding-right pl-5 py-5">
        <div className="p_review_list custom-scroll-style custom-small-scroll-style">
          {loading ? (
            <TableLoader />
          ) : list && list.length > 0 ? (
            list.map((item, index) => (
              <React.Fragment key={index}>
                <div className="mb-0 position-relative p-3 rounded border border-1 ribbon ribbon-clip ribbon-right bg-gray-300">
                  {item?.orderRefId ? (
                    <div className="ribbon-target" style={{ top: "2px" }}>
                      <span className="ribbon-inner bg-warning"></span>
                      Verified Purchase
                    </div>
                  ) : null}

                  <div className="d-flex align-items-center mt-3">
                    <div className="symbol symbol-50 symbol-light mr-5 border border-1 border-light-dark">
                      <span className="symbol-label">
                        <img
                          src={item?.productImageUrl || media.ak_logo}
                          className="h-60 align-self-center"
                          alt=""
                        />
                      </span>
                    </div>
                    <div className="d-flex flex-column flex-grow-1">
                      <span className="text-dark font-weight-bolder font-size-md mb-1 m-0 text-capitalize">
                        {item?.productName?.en}
                      </span>
                      <span className="text-dark-50 font-weight-normal font-size-sm">
                        {moment.utc(item?.lastUpdatedDate).local().format(
                          "DD/MM/YYYY / hh:mm A",
                        )}
                      </span>
                      <span className="text-dark-50 font-weight-normal font-size-sm text-capitalize">
                        {item?.message}
                      </span>
                    </div>
                  </div>
                  <p className="m-0 text-right">
                    <span className="badge badge-primary font-weight-bolder mt-0 text-right text-white">
                      Posted By : {item?.name?.en}
                    </span>
                  </p>
                </div>
                <div className="separator separator-solid my-3"></div>
              </React.Fragment>
            ))
          ) : (
            <p>No data found</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductReviews;
